import { useState } from 'react'
import { adminService } from 'core/services/adminService'
import { toast } from 'react-toastify'

import c from './assets/sass/marketing-item.module.scss'

export const MarketingItem = ({ campaign, onEdit, onUpdate }) => {
    const [sending, setSending] = useState(false)
    const [toggling, setToggling] = useState(false)
    const [stats, setStats] = useState(null)

    const handleSend = async () => {
        if (!campaign.isActive) {
            toast('Сначала включите кампанию', { type: 'warning' })
            return
        }

        if (
            !window.confirm(
                `Отправить кампанию "${campaign.title}" новым пользователям?`
            )
        ) {
            return
        }

        try {
            setSending(true)
            const result = await adminService.sendMarketingCampaign(campaign.id)

            if (result.alreadyReceived > 0) {
                toast(
                    `Отправлено ${result.sentCount} новым пользователям. ${result.alreadyReceived} уже получали.`,
                    { type: 'info' }
                )
            } else {
                toast(`Отправлено ${result.sentCount} пользователям`, {
                    type: 'success',
                })
            }

            onUpdate()
        } catch (error) {
            toast('Ошибка отправки: ' + error.message, { type: 'error' })
        } finally {
            setSending(false)
        }
    }

    const handleToggle = async () => {
        try {
            setToggling(true)
            const result = await adminService.toggleMarketingCampaign(
                campaign.id
            )
            toast(
                result.isActive ? 'Кампания включена' : 'Кампания выключена',
                { type: 'success' }
            )
            onUpdate()
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        } finally {
            setToggling(false)
        }
    }

    const handleDelete = async () => {
        if (!window.confirm(`Удалить кампанию "${campaign.title}"?`)) {
            return
        }

        try {
            await adminService.deleteMarketingCampaign(campaign.id)
            toast('Кампания удалена', { type: 'success' })
            onUpdate()
        } catch (error) {
            toast('Ошибка удаления: ' + error.message, { type: 'error' })
        }
    }

    const handleLoadStats = async () => {
        try {
            const data = await adminService.getMarketingCampaignStats(
                campaign.id
            )
            setStats(data.stats)
        } catch (error) {
            toast('Ошибка загрузки статистики', { type: 'error' })
        }
    }

    const getTargetText = () => {
        const targets = []
        if (campaign.targetAll) targets.push('Все')
        if (campaign.targetActive7) targets.push('7д')
        if (campaign.targetActive14) targets.push('14д')
        if (campaign.targetActive30) targets.push('30д')
        return targets.join(', ') || 'Не выбрано'
    }

    const getPromoInfo = () => {
        const codesCount = campaign.promoCodes?.length || 0

        if (campaign.prizeType === 'case') {
            if (codesCount === 0) return 'Кейс (без промокодов)'
            if (codesCount === 1) return 'Кейс (1 промокод на всех)'
            return `Кейс (${codesCount} промокодов)`
        }

        if (codesCount === 0) return 'Чистый маркетинг (без промокода)'
        if (codesCount === 1) return '1 промокод на всех'
        return `${codesCount} промокодов`
    }

    return (
        <div className={c.component}>
            <div className={c.header}>
                <div className={c.info}>
                    <span className={c.title}>{campaign.title}</span>
                    <span className={c.description}>
                        {campaign.description}
                    </span>
                    <span className={c.meta}>
                        Тип: {campaign.prizeType} | Аудитория: {getTargetText()}
                    </span>
                    <span className={c.meta}>{getPromoInfo()}</span>
                    <span className={c.meta}>
                        Создано уведомлений: {campaign.sentCount} | Получили:{' '}
                        {campaign.stats?.totalSent || 0}
                    </span>
                </div>
                <div className={c.status}>
                    <span className={campaign.isActive ? c.active : c.inactive}>
                        {campaign.isActive ? 'Активна' : 'Неактивна'}
                    </span>
                </div>
            </div>
            {campaign.stats && (
                <div className={c.stats}>
                    <span>Отправлено: {campaign.stats.totalSent}</span>
                    <span>Просмотрено: {campaign.stats.totalViewed}</span>
                    <span>Кликнуто: {campaign.stats.totalClicked}</span>
                </div>
            )}
            {stats && (
                <div className={c.detailedStats}>
                    <p>View Rate: {stats.viewRate}%</p>
                    <p>Click Rate: {stats.clickRate}%</p>
                </div>
            )}
            <div className={c.actions}>
                <button
                    onClick={handleToggle}
                    disabled={toggling}
                    className={
                        campaign.isActive ? c.deactivateBtn : c.activateBtn
                    }
                >
                    {toggling
                        ? '...'
                        : campaign.isActive
                          ? 'Выключить'
                          : 'Включить'}
                </button>
                <button onClick={onEdit} className={c.editBtn}>
                    Редактировать
                </button>
                <button
                    onClick={handleSend}
                    disabled={sending || !campaign.isActive}
                    className={c.sendBtn}
                >
                    {sending ? 'Отправка...' : 'Отправить новым'}
                </button>
                <button onClick={handleLoadStats} className={c.statsBtn}>
                    Статистика
                </button>
                <button onClick={handleDelete} className={c.deleteBtn}>
                    Удалить
                </button>
            </div>
        </div>
    )
}
